module.exports = __webpack_public_path__ + "img/LUB00318.100aa1ab.svg";